import { render, staticRenderFns } from "./NavbarTest.vue?vue&type=template&id=562b234a&scoped=true"
import script from "./NavbarTest.vue?vue&type=script&lang=js"
export * from "./NavbarTest.vue?vue&type=script&lang=js"
import style0 from "./NavbarTest.vue?vue&type=style&index=0&id=562b234a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b234a",
  null
  
)

export default component.exports